// extracted by mini-css-extract-plugin
module.exports = {"mediaPlayer":"mediaReel-player_mediaPlayer__GFT9w"};